export const CHILD_DIV = {
    a: 10, // 子供A(小学生 高学年)
    b: 15, // 子供B(小学生 低学年)
    c: 20, // 子供C(幼児 食事・布団付)
    d: 30, // 子供D(幼児 食事のみ)
    e: 40, // 子供E(幼児 布団のみ)
    f: 50 // 子供F(幼児 食事布団不要)
}